module.exports = __webpack_public_path__ + "img/2-2.aeb00c5c.png";